module.exports = __webpack_public_path__ + "img/icon-refresh.34e46718.svg";